/* eslint-disable react-hooks/rules-of-hooks */
import get from 'lodash/get';

import Banner from 'components/elements/banner';
import Maybe from 'components/elements/maybe';
import { AdsServices,AdsType } from 'lib/apis/services/ads';
import { usePlpStore } from '../../DataStore';
import RelatedLink from './relatedLink';
import { useGlobalStore } from '../../../../../lib/DataStore';

export default function SideBar() {
  const { seoResult, filterData } = usePlpStore();
  const { userDevice } = useGlobalStore();
  const device = !userDevice.trim().length?'DESKTOP':userDevice

  const {data} = AdsServices.useGetBannerQuery({
    ...(filterData.region_IN && {
      regionId: (typeof filterData.region_IN === 'string')?filterData.region_IN.split(',')[0]:[]
    }),
    ...(filterData.city && {
      cityId: filterData.city,
    }),
    device_type: device
  })
  let bannerLeftTop: AdsType.BannerItemNewVersion | undefined = undefined,
    bannerLeftDownFirst: AdsType.BannerItemNewVersion | undefined = undefined,
    bannerLeftDownTow: AdsType.BannerItemNewVersion | undefined = undefined;
  if(data){
    const topIndex = data.data.findIndex(item => item.positionSlug === 'LEFT_CORNER_UP');
    const downFirstIndex = data.data.findIndex(item => item.positionSlug === 'LEFT_CORNER_DOWN');
    const downTowIndex = data.data.findIndex(item => item.positionSlug === 'LEFT_CORNER_DOWN_2');
    if(topIndex > -1){
      bannerLeftTop = {
        ...data.data[topIndex],
        width: 250,
        height: 250
      }
    }
    if(downFirstIndex > -1){
      bannerLeftDownFirst = {
        ...data.data[downFirstIndex],
        width: 240,
        height: 400
      }
    }
    if(downTowIndex > -1){
      bannerLeftDownTow = {
        ...data.data[downTowIndex],
        width: 240,
        height: 400
      }
    }
  }

  return (
    <div className="hidden md:flex flex-col side flex-initial md:max-w-[20%] md:min-w-[20%] sticky top-[160px] h-fit space-y-4">
      {/*left corner top banner*/}
      {bannerLeftTop !== undefined && (
        <Banner token={bannerLeftTop.id} {...bannerLeftTop} />
      )}
      <Maybe
        condition={seoResult?.links !== null && (get(seoResult, 'links', []) as []).length > 0}
      >
        <div className="w-full p-2 space-y-2 bg-white rounded-lg shadow-md h-fit ring-1 ring-grey-300 bottom-60">
          <RelatedLink {...seoResult} />
        </div>
      </Maybe>

      {/*left corner down banners*/}
      {bannerLeftDownFirst !== undefined && (
        <>
          <Banner token={bannerLeftDownFirst.id} {...bannerLeftDownFirst} />
        </>
      )}
      {bannerLeftDownTow !== undefined && (
        <>
          <Banner token={bannerLeftDownTow.id} {...bannerLeftDownTow} />
        </>
      )}
    </div>
  );
}
